import { useAppSelector } from '../../Store';

import * as selectors from './selectors';

export const useSelectCourses = () => useAppSelector(selectors.selectCourses);
export const useSelectAreCoursesLoading = () => useAppSelector(selectors.selectAreCoursesLoading);
export const useSelectIsCoursesLoaded = () => useAppSelector(selectors.selectIsCoursesLoaded);
export const useSelectAreTagsLoading = () => useAppSelector(selectors.selectAreTagsLoading);
export const useSelectCoursesViewMode = () => useAppSelector(selectors.selectCoursesViewMode);

export const useSelectIsCourseCreating = () => useAppSelector(selectors.selectIsCourseCreating);
export const useSelectIsCourseUpdating = () => useAppSelector(selectors.selectIsCourseUpdating);

export const useSelectIsCourseForEditLoading = () =>
  useAppSelector(selectors.selectIsCourseForEditLoading);

export const useSelectCourseForEditError = () => useAppSelector(selectors.selectCourseForEditError);

export const useSelectIsFreshStartCreating = () =>
  useAppSelector(selectors.selectIsFreshStartCreating);
export const useSelectHasCoursesData = () => useAppSelector(selectors.selectHasCoursesData);
export const useSelectTestCourse = () => useAppSelector(selectors.selectTestCourse);
export const useSelectFilteredCourses = () => useAppSelector(selectors.selectFilteredCourses);
export const useSelectIsCourseManagementBusy = () =>
  useAppSelector(selectors.selectIsCourseManagementBusy);
export const useSelectCoursesIds = () => useAppSelector(selectors.selectCoursesIds);
export const useSelectIsCreateCourseSuccess = () =>
  useAppSelector(selectors.selectIsCreateCourseSuccess);
export const useSelectIsUpdateCourseSuccess = () =>
  useAppSelector(selectors.selectIsUpdateCourseSuccess);
export const useSelectCreateCourseResult = () => useAppSelector(selectors.selectCreateCourseResult);
export const useSelectUpdateCourseResult = () => useAppSelector(selectors.selectUpdateCourseResult);
export const useSelectStandalones = () => useAppSelector(selectors.selectStandalones);
export const useSelectAreStandalonesLoading = () =>
  useAppSelector(selectors.selectAreStandalonesLoading);

export const useSelectCourse = (id: string) =>
  useAppSelector(state => selectors.selectCourse(state, id));
export const useSelectCourseParticipants = (id: string) =>
  useAppSelector(state => selectors.selectCourseParticipants(state, id));
export const useSelectCourseMyDesktop = (id: string) =>
  useAppSelector(state => selectors.selectCourseMyDesktop(state, id));
export const useSelectCourseTrainerDesktop = (id: string) =>
  useAppSelector(state => selectors.selectCourseTrainerDesktop(state, id));
export const useSelectCourseFreshStartDesktop = (id: string) =>
  useAppSelector(state => selectors.selectCourseFreshStartDesktop(state, id));
export const useSelectAreParticipantsLoading = (id: string) =>
  useAppSelector(state => selectors.selectAreParticipantsLoading(state, id));
export const useSelectIsJoinCodeLoading = (id: string) =>
  useAppSelector(state => selectors.selectIsJoinCodeLoading(state, id));
export const useSelectIsMyDesktopLoading = (id: string) =>
  useAppSelector(state => selectors.selectIsMyDesktopLoading(state, id));
export const useSelectIsTrainerDesktopLoading = (id: string) =>
  useAppSelector(state => selectors.selectIsTrainerDesktopLoading(state, id));
export const useSelectIsFreshStartDesktopLoading = (id: string) =>
  useAppSelector(state => selectors.selectIsFreshStartDesktopLoading(state, id));
export const useSelectIsAnyDesktopLoading = (id: string) =>
  useAppSelector(state => selectors.selectIsAnyDesktopLoading(state, id));
export const useSelectIsAnyDesktopPending = (id: string) =>
  useAppSelector(state => selectors.selectIsAnyDesktopPending(state, id));
export const useSelectCourseExists = (id: string) =>
  useAppSelector(state => selectors.selectCourseExists(state, id));
export const useSelectHasCourseDesktops = (id: string) =>
  useAppSelector(state => selectors.selectHasCourseDesktops(state, id));
export const useSelectHasCourseParticipants = (id: string) =>
  useAppSelector(state => selectors.selectHasCourseParticipants(state, id));
export const useSelectIsCourseReady = (id: string) =>
  useAppSelector(state => selectors.selectIsCourseReady(state, id));
export const useSelectCanPreviewCourse = (id: string) =>
  useAppSelector(state => selectors.selectCanPreviewCourse(state, id));
export const useSelectHasMyDesktop = (id: string) =>
  useAppSelector(state => selectors.selectHasMyDesktop(state, id));
export const useSelectHasTrainerDesktop = (id: string) =>
  useAppSelector(state => selectors.selectHasTrainerDesktop(state, id));
export const useSelectHasFreshStartDesktop = (id: string) =>
  useAppSelector(state => selectors.selectHasFreshStartDesktop(state, id));
export const useSelectIsMyDesktopRunning = (id: string) =>
  useAppSelector(state => selectors.selectIsMyDesktopRunning(state, id));
export const useSelectIsTrainerDesktopRunning = (id: string) =>
  useAppSelector(state => selectors.selectIsTrainerDesktopRunning(state, id));
export const useSelectIsFreshStartDesktopRunning = (id: string) =>
  useAppSelector(state => selectors.selectIsFreshStartDesktopRunning(state, id));
export const useSelectIsFreshStartDesktopStartPending = (id: string) =>
  useAppSelector(state => selectors.selectIsFreshStartDesktopStartPending(state, id));
export const useSelectIsFreshStartDesktopStopPending = (id: string) =>
  useAppSelector(state => selectors.selectIsFreshStartDesktopStopPending(state, id));
export const useSelectIsFreshStartDesktopDeletePending = (id: string) =>
  useAppSelector(state => selectors.selectIsFreshStartDesktopDeletePending(state, id));
export const useSelectFreshStartDesktopLink = (id: string) =>
  useAppSelector(state => selectors.selectFreshStartDesktopLink(state, id));
export const useSelectIsMyDesktopStartPending = (id: string) =>
  useAppSelector(state => selectors.selectIsMyDesktopStartPending(state, id));
export const useSelectIsMyDesktopStopPending = (id: string) =>
  useAppSelector(state => selectors.selectIsMyDesktopStopPending(state, id));
export const useSelectIsMyDesktopDeletePending = (id: string) =>
  useAppSelector(state => selectors.selectIsMyDesktopDeletePending(state, id));
export const useSelectMyDesktopLink = (id: string) =>
  useAppSelector(state => selectors.selectMyDesktopLink(state, id));
export const useSelectIsTrainerDesktopStartPending = (id: string) =>
  useAppSelector(state => selectors.selectIsTrainerDesktopStartPending(state, id));
export const useSelectIsTrainerDesktopStopPending = (id: string) =>
  useAppSelector(state => selectors.selectIsTrainerDesktopStopPending(state, id));
export const useSelectFreshStartServersForCourse = (courseId: string) =>
  useAppSelector(state => selectors.selectFreshStartServersForCourse(state, courseId));
export const useSelectAreFreshStartServersLoading = (courseId: string) =>
  useAppSelector(state => selectors.selectAreFreshStartServersLoading(state, courseId));
export const useSelectOsTemplatesOfServer = (serverName: string) =>
  useAppSelector(state => selectors.selectOsTemplatesOfServer(state, serverName));
export const useSelectAreOsTemplatesLoading = (serverName: string) =>
  useAppSelector(state => selectors.selectAreOsTemplatesLoading(state, serverName));
export const useSelectOsTemplatesError = (serverName: string) =>
  useAppSelector(state => selectors.selectOsTemplatesError(state, serverName));

export const useSelectIsParticipantDesktopStartPending = (
  courseId: string,
  participantId: string
) => useAppSelector(selectors.selectIsParticipantDesktopStartPending(courseId, participantId));
export const useSelectIsParticipantDesktopStopPending = (courseId: string, participantId: string) =>
  useAppSelector(selectors.selectIsParticipantDesktopStopPending(courseId, participantId));
export const useSelectIsParticipantDesktopDeletePending = (
  courseId: string,
  participantId: string
) => useAppSelector(selectors.selectIsParticipantDesktopDeletePending(courseId, participantId));

export const useSelectParticipantDesktopViewLink = (courseId: string, participantId: string) =>
  useAppSelector(state =>
    selectors.selectParticipantDesktopViewLink(state, courseId, participantId)
  );

export const useSelectAvailableTagsWithTranslations = () =>
  useAppSelector(state => state.courses.availableTagsWithTranslations);

export const useCoursesViewMode = () => useAppSelector(state => state.courses.courseListViewMode);

export const useCoursesAvailableTags = () =>
  useAppSelector(state => ({
    tags: state.courses.availableTagsWithTranslations,
    isLoading: state.courses.areTagsLoading
  }));

export const useSelectCoursesError = () => useAppSelector(selectors.selectCoursesError);
export const useSelectCoursesPagination = () => useAppSelector(selectors.selectCoursesPagination);
